import { Stack } from '@mantine/core';
import classNames from 'classnames/bind';
import { Panel } from 'components/index';
import { PageTitle } from 'components/PageTitle';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import { useEffect } from 'react';
import { type RouteChildrenProps, useHistory } from 'react-router';
import { onBoardingActions } from 'store/onBoarding/onBoarding.actions';
import { INTEGRATIONS_ROUTE, Integration } from '../../Integrations.constants';
import { INTEGRATION_UPDATE_CALLBACK } from '../Integration.constants';
import styleIdentifiers from '../Integration.module.scss';
import { useGetIntegrationRights } from '../Integration.utils';
import { IntegrationHeader } from '../IntegrationHeader';
import { CodaboxForm, type CodaboxFormFields } from './CodaboxForm';

const styles = classNames.bind(styleIdentifiers);

export const Codabox = ({ history: { replace } }: RouteChildrenProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const company = useCompanyConfiguration();
  const getIntegrationRights = useGetIntegrationRights();

  const { canActivate, isActive } = getIntegrationRights(Integration.CODABOX);
  useEffect(() => {
    if (!canActivate && !isActive) {
      replace(INTEGRATIONS_ROUTE);
    }
  }, [canActivate, isActive, replace]);

  if (!company?.tp_accounting) {
    return (
      <div className={styles('loading')}>
        <div>{t(i18nKeys.LOADING)}</div>
      </div>
    );
  }

  const handleSubmit = (data: CodaboxFormFields) => {
    onBoardingActions.codaboxToken({
      settings: true,
      data,
      callback: () => {
        INTEGRATION_UPDATE_CALLBACK();
        history.push('/settings/integrations');
      },
    });
  };

  const tokenRequest = () =>
    onBoardingActions.codaboxRequest({
      settings: true,
      callback: (data: any) => {
        onBoardingActions.changeCodaboxMessage(data.message);
      },
    });

  return (
    <>
      <PageTitle>
        <PageTitle.Back />
        {Integration.CODABOX}
        <PageTitle.Actions>
          <IntegrationHeader name={Integration.CODABOX} />
        </PageTitle.Actions>
      </PageTitle>
      <Stack>
        <Panel>
          <CodaboxForm onSubmit={handleSubmit} tokenRequest={tokenRequest} />
        </Panel>
      </Stack>
    </>
  );
};
